import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

// 全局状态（包括用户信息和一些通用的数据等.）
const state = {
  // 用户信息
  user: {
    id: '',
    name: '',
    email: '',
    roles: [],
    is_superuser: 0,
    out() {
      window.localStorage.removeItem('userInfo')
      window.location.href = '/api/sso/logout'
    },
  },
  // 菜单
  menu: [{}],
  // 权限信息
  perm: {
    ader: {},
    aff: {},
    offer: {},
    setting: {},
    report: {},
    payment: {},
    team_users: [],
  },
  permList: [],
  // 广告主相关的列表
  ader_setting: {
    tracking_link_clickid: [],
    tracking_link_channel: [],
    tracking_link_subchannel: [],
    tracking_link_android_ios: [],
  },
  ad_setting: {}, // 广告相关的列表
  aff_setting: {},
  offer_setting: {},
  channel_setting: {},
  finance_setting: {},
  countries: [], // 国家列表
  os_setting: [],
  code_reason: {},
  criticism_reason: [],
  recommend_type: [],
  carriers: {}, // 对应每个国家的carrier的对象
  all_carriers: [], // 包含所有国家下的carrier数组
  timezone: [], // 时区列表
  timezonev1: [], // 时区列表
  role: {}, // 角色对应的id
  includes: [], // 需要缓存的页面组件 (这个可以删掉了，但要先检查一下其他地方有没有用到，缓存页面一律是用subRouteView)
  form_origin: {}, // 保存表单上次输入的数据
  aso_ader_setting: {}, // ASO广告主相关的列表
}

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
})
